import { SearchTipProps } from "./styles";

export const SEARCH_TIPS: SearchTipProps[] = [
  {
    keyword: "“ ”",
    label: "Search for an exact phrase",
    example: "“Read AI”",
  },
  {
    keyword: "OR",
    label: "Search for either term (or both)",
    example: "Tuesday OR Tues",
  },
  { keyword: "-", label: "Exclude term from search", example: "read -ai" },
];
